"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMultiSelector = createMultiSelector;
var _reselect = require("reselect");
var multiSelectorIndex = 0;
var multiSelectors = {};
function createMultiSelector(inputSelectors, resultFunc) {
  var selectors = {};
  var multiSelector = function multiSelector(state, id) {
    var selectorId = String(id);
    if (!Object.hasOwnProperty.call(selectors, selectorId)) {
      selectors[selectorId] = (0, _reselect.createSelector)(inputSelectors, resultFunc);
    }
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return selectors[selectorId].apply(selectors, [state, id].concat(args));
  };
  multiSelectors[multiSelectorIndex] = multiSelector;
  multiSelectorIndex += 1;

  // Only assign to window if we are in the browser environment
  if (typeof window !== 'undefined') {
    window.multiSelectors = multiSelectors;
  }
  return multiSelector;
}